module.exports = __webpack_public_path__ + "static/mark-26f169546653a6aed8a63c21c7097cf5.mp4";